import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import {
  CURRENCY_STORAGE_KEY,
  getCurrencyByCode,
  normalizeCurrencyCode,
} from 'helpers/currencyHelper';

const CurrencyContext = createContext({
  currency: '',
  setCurrency: () => {},
  formatAmount: (value) => String(value),
});

export function CurrencyProvider({ children }) {
  const [currency, setCurrencyState] = useState('');

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.localStorage.removeItem(CURRENCY_STORAGE_KEY);
    }
  }, []);

  const value = useMemo(
    () => ({
      currency,
      setCurrency: (nextCurrency) => {
        setCurrencyState(normalizeCurrencyCode(nextCurrency));
      },
      formatAmount: (amount) => {
        try {
          const currencyObj = getCurrencyByCode(currency);
          if (!currencyObj) return String(amount);
          return new Intl.NumberFormat(currencyObj.locale, {
            style: 'currency',
            currency: currencyObj.code,
          }).format(amount);
        } catch {
          return String(amount);
        }
      },
    }),
    [currency]
  );

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  return useContext(CurrencyContext);
}
